import { render } from "./ZhaiHead.vue?vue&type=template&id=7aa5af48&scoped=true"
import script from "./ZhaiHead.vue?vue&type=script&lang=js"
export * from "./ZhaiHead.vue?vue&type=script&lang=js"

import "./ZhaiHead.vue?vue&type=style&index=0&id=7aa5af48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa5af48"]])

export default __exports__